import { render, staticRenderFns } from "./form-style.vue?vue&type=template&id=610841bd&"
import script from "./form-style.vue?vue&type=script&lang=js&"
export * from "./form-style.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports